import {
  TypesOfTrackingEvents,
  useTrackElement,
} from '@edreamsodigeo/frontend-core';
import React, { memo } from 'react';

import { getDatameshEventId } from './getDatameshEventId';
import { DatameshFlow, DatameshIds } from './models';

const EVENT_TO_TRACK = 'display';
const EVENT_TO_TRACK_ARR: TypesOfTrackingEvents[] = ['display'];

export const DatameshComponentLoad = memo(
  ({
    products,
    datameshId,
    datameshFlow,
  }: {
    products: string[];
    datameshId: DatameshIds;
    datameshFlow: DatameshFlow;
  }) => {
    const id = React.useMemo(
      () =>
        getDatameshEventId({
          datameshFlow,
          datameshEvent: EVENT_TO_TRACK,
          datameshId,
          productTypes: products,
        }),
      [datameshFlow, datameshId, products]
    );
    const trackingRef = useTrackElement(EVENT_TO_TRACK_ARR, id);
    return <div ref={trackingRef}></div>;
  }
);
